// extracted by mini-css-extract-plugin
export default {"price":"Price_price__Fo+df","amount":"Price_amount__JHq9P"};